import Breadcrumbs from '@v2/shared/components/Breadcrumbs';
import ContentCard from '@v2/shared/components/ContentCard';
import DocumentHtml from '@v2/shared/components/DocumentHtml';
import PageHeading from '@v2/shared/components/PageHeading';

export type Props = {
  /** The policy itself, from the site's own `includes/modules/legal/privacy/`. */
  html: string;
};

/**
 * /privacy, on every brand but DiscountMags.
 *
 * Shared for the same reason the terms page is: `privacyVersion` picks one of a set of
 * dated documents at request time, each brand's `privacy_contents.html` resolves to its
 * own directory, and what is left here is a frame.
 *
 * DiscountMags keeps `brands/discountmags/Pages/PrivacyPolicy` because its heading reads
 * "Our Privacy Policy" rather than "Privacy Policy", and `resolve.ts` tries the brand
 * before shared — so that one file is the whole of the difference.
 */
export default function PrivacyPolicy({ html }: Props) {
  return (
    <>
      <Breadcrumbs items={[{ label: 'Home', href: '/' }, { label: 'Privacy Policy' }]} />

      <PageHeading eyebrow="Customer Information">Privacy Policy</PageHeading>

      <ContentCard className="prose mt-6">
        <DocumentHtml html={html} />
      </ContentCard>
    </>
  );
}

PrivacyPolicy.layoutName = 'Layouts.Institutional';
